var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("el-backtop", {
    attrs: {
      bottom: 100
    }
  }, [_c("div", {
    staticStyle: {
      height: "100%",
      width: "100%",
      "background-color": "var(--el-bg-color-overlay)",
      "box-shadow": "var(--el-box-shadow-lighter)",
      "text-align": "center",
      "line-height": "40px",
      color: "#1989fa",
      display: "flex",
      "align-items": "center",
      "justify-content": "center",
      "border-radius": "50%"
    }
  }, [_c("i", {
    staticClass: "el-icon-arrow-up",
    staticStyle: {
      "font-size": "20px"
    }
  })])]), _c("div", {
    staticClass: "filter-header",
    staticStyle: {
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "10px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      size: "mini"
    },
    on: {
      click: function ($event) {
        _vm.showFilters = !_vm.showFilters;
      }
    }
  }, [_vm._v(" Filters & More "), _c("i", {
    class: _vm.showFilters ? "el-icon-arrow-up" : "el-icon-arrow-down",
    staticStyle: {
      "margin-left": "5px"
    }
  })])], 1), _vm.showFilters ? _c("div", {
    staticClass: "filter-container"
  }, [_c("el-select", {
    staticClass: "filter-item",
    attrs: {
      multiple: "",
      "collapse-tags": "",
      clearable: "",
      placeholder: "Payment Type"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.paymentType,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "paymentType", $$v);
      },
      expression: "listQuery.paymentType"
    }
  }, _vm._l(_vm.paymentTypeOptions, function (option) {
    return _c("el-option", {
      key: option.value,
      attrs: {
        label: option.label,
        value: option.value
      }
    });
  }), 1), _c("el-select", {
    attrs: {
      multiple: "",
      "collapse-tags": "",
      filterable: "",
      clearable: "",
      name: "branchId",
      placeholder: "Select Branch"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.branchId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "branchId", $$v);
      },
      expression: "listQuery.branchId"
    }
  }, _vm._l(_vm.branchList, function (branch) {
    return _c("el-option", {
      key: branch.id,
      attrs: {
        label: branch.code,
        value: branch.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      remote: "",
      loading: _vm.dealerListLoading,
      "loading-text": "fetching dealers..",
      "remote-method": _vm.getDealerList,
      placeholder: "Dealer"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.dealerId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "dealerId", $$v);
      },
      expression: "listQuery.dealerId"
    }
  }, _vm._l(_vm.dealerList, function (dealer) {
    return _c("el-option", {
      key: dealer.id,
      attrs: {
        label: dealer.name,
        value: dealer.id
      }
    }, [_c("span", {
      staticStyle: {
        float: "left",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(dealer.name) + " - " + _vm._s(dealer.code))]), _c("span", {
      staticStyle: {
        float: "right",
        color: "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v("   | ID: " + _vm._s(dealer.id))])]);
  }), 1), !_vm.isAgent ? _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      clearable: "",
      placeholder: "Agent"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.agentId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "agentId", $$v);
      },
      expression: "listQuery.agentId"
    }
  }, _vm._l(_vm.agentList, function (agent) {
    return _c("el-option", {
      key: agent.id,
      attrs: {
        label: agent.name,
        value: agent.id
      }
    });
  }), 1) : _vm._e(), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      multiple: "",
      "collapse-tags": "",
      filterable: "",
      clearable: "",
      placeholder: "States"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.stateId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "stateId", $$v);
      },
      expression: "listQuery.stateId"
    }
  }, _vm._l(_vm.stateList, function (state) {
    return _c("el-option", {
      key: state.id,
      attrs: {
        label: state.name,
        value: state.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      placeholder: "Cities"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.listQuery.cityName,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "cityName", $$v);
      },
      expression: "listQuery.cityName"
    }
  }, _vm._l(_vm.cityList, function (city) {
    return _c("el-option", {
      key: city.id,
      attrs: {
        label: city.name,
        value: city.name
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      clearable: "",
      filterable: "",
      multiple: "",
      "collapse-tags": "",
      placeholder: "Range"
    },
    on: {
      change: _vm.handleCategoryFilter
    },
    model: {
      value: _vm.listQuery.rangeId,
      callback: function ($$v) {
        _vm.$set(_vm.listQuery, "rangeId", $$v);
      },
      expression: "listQuery.rangeId"
    }
  }, _vm._l(_vm.rangeList, function (range) {
    return _c("el-option", {
      key: range.id,
      attrs: {
        label: range.name,
        value: range.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.listQuery.rangeId,
      clearable: "",
      multiple: "",
      filterable: "",
      placeholder: "Category"
    },
    on: {
      change: _vm.handleSubCategoryFilter
    },
    model: {
      value: _vm.categoryId,
      callback: function ($$v) {
        _vm.categoryId = $$v;
      },
      expression: "categoryId"
    }
  }, _vm._l(_vm.categoryList, function (category) {
    return _c("el-option", {
      key: category.id,
      attrs: {
        label: category.name,
        value: category.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      disabled: !_vm.categoryId,
      clearable: "",
      multiple: "",
      filterable: "",
      placeholder: "Sub Category"
    },
    on: {
      change: _vm.handleFilter
    },
    model: {
      value: _vm.subCategoryId,
      callback: function ($$v) {
        _vm.subCategoryId = $$v;
      },
      expression: "subCategoryId"
    }
  }, _vm._l(_vm.subCategoryList, function (category) {
    return _c("el-option", {
      key: category.id,
      attrs: {
        label: category.name,
        value: category.id
      }
    });
  }), 1), _c("el-select", {
    staticClass: "filter-item",
    attrs: {
      filterable: "",
      remote: "",
      multiple: "",
      clearable: "",
      "remote-method": _vm.getProductList,
      loading: _vm.productListLoading,
      placeholder: "Select Product"
    },
    on: {
      change: _vm.handleProductSelection
    },
    model: {
      value: _vm.selectedProduct,
      callback: function ($$v) {
        _vm.selectedProduct = $$v;
      },
      expression: "selectedProduct"
    }
  }, _vm._l(_vm.products, function (product) {
    return _c("el-option-group", {
      key: product.id,
      attrs: {
        label: "Main Product"
      }
    }, [_c("el-option", {
      key: "product-" + product.id,
      attrs: {
        label: product.name,
        value: "product-" + product.id
      }
    }, [_c("span", {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(product.name))])]), product.productType !== "simple" && product.productsVariation && product.productsVariation.length ? [_c("el-option", {
      key: "variations-label-" + product.id,
      attrs: {
        label: "Variations",
        disabled: ""
      }
    }, [_c("span", {
      staticStyle: {
        "font-style": "italic",
        color: "gray"
      }
    }, [_vm._v("Variations:")])]), _vm._l(product.productsVariation, function (item) {
      return _c("el-option", {
        key: item.id,
        attrs: {
          label: product.name + "-" + item.name,
          value: "variation-" + item.id
        }
      }, [_c("span", [_vm._v(_vm._s(item.name))])]);
    })] : _vm._e()], 2);
  }), 1), _c("VueCtkDateTimePicker", {
    staticClass: "filter-item",
    attrs: {
      range: "",
      formatted: "DD-MM-YYYY",
      "custom-shortcuts": _vm.shortcuts
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      icon: "el-icon-search",
      size: "mini"
    },
    on: {
      click: _vm.handleSearch
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("table.search")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "primary",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleExcelDownload
    }
  }, [_vm._v(" Export as Excel ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "danger",
      size: "mini",
      icon: "el-icon-document"
    },
    on: {
      click: _vm.handleClearCache
    }
  }, [_vm._v(" Clear Cache ")])], 1) : _vm._e(), !_vm.hasSearched ? _c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "60px 0",
      color: "#909399",
      "font-size": "16px"
    }
  }, [_c("i", {
    staticClass: "el-icon-search",
    staticStyle: {
      "font-size": "40px",
      "margin-bottom": "10px",
      display: "block"
    }
  }), _vm._v(" Please apply filters and click "), _c("b", [_vm._v("Search")]), _vm._v(" to load data. ")]) : _vm._e(), _vm.hasSearched ? _c("div", {
    staticClass: "legend",
    staticStyle: {
      display: "flex",
      gap: "16px",
      "margin-bottom": "8px",
      "font-size": "12px",
      "align-items": "center",
      "flex-wrap": "wrap"
    }
  }, _vm._l(_vm.paymentTypeLegend, function (item) {
    return _c("span", {
      key: item.type,
      staticStyle: {
        display: "inline-flex",
        "align-items": "center",
        gap: "4px"
      }
    }, [_c("span", {
      staticClass: "legend-swatch",
      class: _vm.paymentTypeRowClass({
        paymentType: item.type
      })
    }), _vm._v(" " + _vm._s(item.type) + " ")]);
  }), 0) : _vm._e(), _vm.hasSearched ? _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.listLoading,
      expression: "listLoading"
    }],
    ref: "table",
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": "",
      height: "410",
      "row-class-name": _vm.getRowClassName
    }
  }, [_c("el-table-column", {
    attrs: {
      width: "80",
      align: "center",
      label: "ID",
      prop: "id"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.id) + " ")];
      }
    }], null, false, 3411552848)
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "dealerName",
      label: "Dealer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.dealerName))])];
      }
    }], null, false, 152579060)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      prop: "stateName",
      label: "State"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.stateName) + " ")];
      }
    }], null, false, 3346302349)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      prop: "cityName",
      label: "City"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.cityName) + " ")];
      }
    }], null, false, 16014653)
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      prop: "agentName",
      label: "Agent"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.agentName))])];
      }
    }], null, false, 179361654)
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      align: "center",
      prop: "invoiceNumber",
      label: "Invoice Number"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.invoiceNumber) + " ")];
      }
    }], null, false, 1328097071)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      prop: "paymentType",
      label: "Type"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("el-tag", {
          attrs: {
            size: "mini",
            type: _vm.paymentTypeTagType(scope.row.paymentType)
          }
        }, [_vm._v(" " + _vm._s(scope.row.paymentType) + " ")])];
      }
    }], null, false, 2226346513)
  }), _c("el-table-column", {
    attrs: {
      width: "150px",
      align: "center",
      prop: "createdOn",
      label: "Invoice Date"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdOn, "DD-MM-YYYY")) + " "), _c("br"), _vm._v(" " + _vm._s(_vm._f("moment")(scope.row.createdOn, "hh:mm a")) + " ")];
      }
    }], null, false, 3907549774)
  }), _c("el-table-column", {
    attrs: {
      prop: "productName",
      label: "Item",
      width: "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("b", [_vm._v(_vm._s(scope.row.productName))]), _vm._v(" "), _c("br"), scope.row.productName !== scope.row.variationName ? _c("small", [_vm._v("(" + _vm._s(scope.row.variationName) + ")")]) : _vm._e()];
      }
    }], null, false, 669474131)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      prop: "rangeName",
      label: "Range"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.rangeName) + " ")];
      }
    }], null, false, 3758245573)
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      align: "center",
      prop: "quantity",
      label: "Quantity(PCS)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.quantity) + " ")];
      }
    }], null, false, 1917492518)
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      prop: "masterCarton",
      label: "Cartons"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(scope.row.masterCarton ? (scope.row.quantity / scope.row.masterCarton).toFixed(1) : "") + " ")];
      }
    }], null, false, 3612348446)
  }), _c("el-table-column", {
    attrs: {
      width: "130",
      align: "center",
      prop: "listRate",
      label: "List Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.listRate
          }
        })];
      }
    }], null, false, 3467155071)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "Policy Discount(%)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s((row === null || row === void 0 ? void 0 : row.policiesPercentDiscount) || "") + " ")];
      }
    }], null, false, 2295827264)
  }), _c("el-table-column", {
    attrs: {
      width: "170",
      align: "center",
      label: "Schemes Discount(%)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s((row === null || row === void 0 ? void 0 : row.schemesPercentDiscount) || "") + " ")];
      }
    }], null, false, 4148907488)
  }), _c("el-table-column", {
    attrs: {
      width: "150",
      align: "center",
      label: "MOQ Discount(%)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        row
      }) {
        return [_vm._v(" " + _vm._s((row === null || row === void 0 ? void 0 : row.moqsDiscount) || "") + " ")];
      }
    }], null, false, 2456617341)
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      align: "center",
      prop: "nettRate",
      label: "Net Rate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.nettRate
          }
        })];
      }
    }], null, false, 3267563958)
  }), _c("el-table-column", {
    attrs: {
      width: "140",
      align: "right",
      label: "Amount",
      prop: "total"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("inr", {
          attrs: {
            number: scope.row.total
          }
        })];
      }
    }], null, false, 577959421)
  }), _c("el-table-column", {
    attrs: {
      width: "200",
      align: "left",
      label: "Description",
      prop: "comments",
      fixed: "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.paymentType !== "Invoice" ? _c("span", [_vm._v(_vm._s(scope.row.comments))]) : _vm._e()];
      }
    }], null, false, 284025067)
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Branch Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Branch Manager")) + " ")];
      }
    }], null, false, 3090038928)
  }), _c("el-table-column", {
    attrs: {
      width: "200px",
      align: "center",
      label: "Zonal Manager"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_vm._v(" " + _vm._s(_vm.getAdminByRole(scope.row.mappedAdmins, "Zonal Manager")) + " ")];
      }
    }], null, false, 925914354)
  })], 1) : _vm._e(), _vm.hasSearched ? _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };